/**
 * Fly-in Config Components.
 */
import { Component, registerComponent } from 'js/component.js';

const componentName = 'fly-in-config';

class FlyIn extends Component {

    /**
     * Component Setup
     */
    elements = {
        body: document.body
    };

    /**
     * Initialize Component
     */
    init() {
        let configPagePath = this.element.getAttribute('data-path');
        const isAuthorRunMode = this.element.getAttribute('data-author-run-mode');

        if (isAuthorRunMode && isAuthorRunMode === 'true') { // Author Environment
            configPagePath += '?wcmmode=disabled';
        }

        this.getFlyInConfigPage(configPagePath);
    }

    getFlyInConfigPage = (url) => {
        fetch(url).then((response) => {
            if (!response.ok) {
                throw new Error('Response failed');
            }
            return response.text();
        }).then((response) => {
            // Parse HTML for alert banner components
            const flyInConfigPage = response;
            const HTMLElement = document.createElement('html');
            HTMLElement.innerHTML = flyInConfigPage;
            const flyInComponents = [...HTMLElement.querySelectorAll('.fly-in')];
            const flyInToDisplay = this.findFlyInToDisplay(flyInComponents);
            if (flyInToDisplay !== -1 && this.elements.body) {
                this.elements.body.insertAdjacentElement('beforeBegin', flyInComponents[flyInToDisplay]);
                window.dispatchEvent(new Event('fly-in-init'));
            }
        });
    };

    findFlyInToDisplay = (flyInComponents) => {
        let pagePath = window.location.pathname.split('.')[0];
        if (pagePath.includes('/content/preview')) {
            pagePath = pagePath.replace('/content/preview', '/content');
        }
        let flyInToDisplay = -1;
        flyInComponents.forEach((alertBannerComponent, index) => {
            let displayPathMatch = false;
            let validTime = false;
            const container = alertBannerComponent.querySelector('.o-flyIn');
            const onTime = container.getAttribute('data-on-time');
            const offTime = container.getAttribute('data-off-time');
            const displayPaths = container.getAttribute('data-display-paths') ? container.getAttribute('data-display-paths').split(',') : [];

            // Check if current time is between onTime and offTime
            const currentTime = new Date();
            const onTimeDate = new Date(onTime);
            const offTimeDate = new Date(offTime);
            if (onTime && offTime && currentTime > onTimeDate && currentTime < offTimeDate) {
                validTime = true;
            } else if (!onTime && !offTime) {
                validTime = true;
            } else {
                return;
            }

            // Check if current page is in displayPaths
            displayPaths.forEach((displayPath) => {
                if (displayPath === '') {
                    return;
                }
                const path = displayPath.split('?includeChildren=')[0];
                const includeChildren = displayPath.split('?includeChildren=')[1] === 'true';
                if (includeChildren) {
                    if (pagePath.includes(path)) {
                        displayPathMatch = true;
                    }
                } else if (pagePath === path) {
                    displayPathMatch = true;
                }
            });

            if (displayPathMatch && validTime) {
                flyInToDisplay = index;
            }
        });
        return flyInToDisplay;
    };
}

registerComponent(`.${componentName}`, FlyIn);
